"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var angular = require("angular");
var Apollo = (function () {
    function Apollo(client, $q) {
        this.client = client;
        this.$q = $q;
    }
    Apollo.prototype.query = function (options) {
        this.check();
        return this.wrap(this.client.query(options));
    };
    Apollo.prototype.mutate = function (options) {
        this.check();
        return this.wrap(this.client.mutate(options));
    };
    Apollo.prototype.check = function () {
        if (!this.client) {
            throw new Error('Client is missing. Use ApolloProvider.defaultClient');
        }
    };
    Apollo.prototype.wrap = function (promise) {
        return this.$q(function (resolve, reject) {
            promise.then(resolve).catch(reject);
        });
    };
    return Apollo;
}());
var ApolloProvider = (function () {
    function ApolloProvider() {
        var _this = this;
        this.$get = ['$q', function ($q) { return new Apollo(_this.client, $q); }];
    }
    ApolloProvider.prototype.defaultClient = function (client) {
        this.client = client;
    };
    return ApolloProvider;
}());
exports.default = angular.module('angular-apollo', [])
    .provider('apollo', new ApolloProvider).name;
//# sourceMappingURL=apollo.provider.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular1-apollo/build/src/apollo.provider.js
// module id = 373
// module chunks = 0